import { observable, action } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';
import TinyInputStore from '@src/components/tiny-input/store';
import Toast from '@src/components/toast';
import { go } from '@src/utils/promise/index';
import captchaHandlerDecorate from '@src/utils/captcha-deco-util';
import * as commonRegex from '@src/utils/common-regex';
import $$tracker from '@src/tracker';
import { getParameterByNames } from '@src/utils/common-util';
import { sendSemReport } from '@src/utils/sem';

// 设备类型枚举
export const DEVICE_TYPES = {
  ANDROID: 'Android',
  IOS: 'iOS',
  HARMONY: 'Harmony',
  PC: 'PC'
};

class OrderModalStore extends BaseModalStore {
  @observable closeCallback = noop;

  // 设备选择状态
  @observable selectedDevices = new Set([]);

  // 协议勾选状态
  @observable isAgreementChecked = true;

  subLoading = false;
  // 手机号输入
  phoneInputStore = new TinyInputStore();

  // 验证码输入
  codeInputStore = new TinyInputStore();

  // 发送验证码loading
  @observable sendingCode = false;

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  /**
   * 切换设备选择
   */
  @action
  toggleDevice = device => {
    if (this.selectedDevices.has(device)) {
      this.selectedDevices.delete(device);
    } else {
      this.selectedDevices.add(device);
    }
    // 触发 mobx 响应
    this.selectedDevices = new Set(this.selectedDevices);
  };

  /**
   * 检查设备是否被选中
   */
  isDeviceSelected = device => {
    return this.selectedDevices.has(device);
  };

  /**
   * 切换协议勾选
   */
  @action
  toggleAgreement = () => {
    this.isAgreementChecked = !this.isAgreementChecked;
  };

  /**
   * 验证手机号
   */
  validatePhone = () => {
    const phone = this.phoneInputStore.value;
    // if (!phone) {
    //   Toast.info('请输入手机号');
    //   return false;
    // }
    if (!phone || !commonRegex.phoneNumber.test(phone)) {
      Toast.info('请输入正确的手机号码');
      return false;
    }
    return true;
  };

  @action.bound
  @captchaHandlerDecorate('zt')
  async onSendVCRequest(authParams) {
    $$tracker.clickGetVerifyCode();
    const [_data, err] = await go(this.$ztService.getPhoneCode(authParams));
    if (err) {
      Toast.fail(err?.message || '发送失败！');
      return false;
    }
    return true;
  }

  /**
   * 提交预约
   */
  @action
  onSubmit = async () => {
    // 验证验证码
    const a = '移动端游戏预约';
    // 获取用户输入的验证码
    const code = this.codeInputStore.value;
    // 设备ID（预留字段，当前为空）
    const device_id = '';
    // 被邀请人UID（预留字段，当前为空）
    const invitee_uid = '';
    // 操作来源，固定为pc端
    const operate_from = 'mo';
    // 获取用户输入的手机号
    const phone = this.phoneInputStore.value;
    // 获取已选中的平台，拼接成逗号分隔的字符串
    const platform = Array.from(this.selectedDevices).join(',');
    // return;
    // 用户代理中的操作系统信息（预留字段，当前为空）
    const ua_os = '';
    // 推广来源（预留字段，当前为空）
    const utm_source = getParameterByNames('utm_source') || '';

    if (!platform) {
      Toast.fail('请选择至少一个设备');
      return;
    }
    if (!phone || !/^1[3-9]\d{9}$/.test(phone)) {
      Toast.info('请输入正确的手机号码');
      return;
    }
    if (!code || code.length !== 6) {
      Toast.fail('请输入正确的验证码');
      return;
    }
    // 验证协议勾选
    if (!this.isAgreementChecked) {
      Toast.fail('请阅读并同意服务使用协议和隐私政策');
      return;
    }

    try {
      this.subLoading = true;
      const [data, err] = await go(this.$ztService.subscribe('移动端游戏预约', code, device_id, invitee_uid, operate_from, phone, platform, ua_os, utm_source));
      this.subLoading = false;
      if (err) {
        $$tracker.phoneReservation('失败');
        Toast.fail(err.message || '预约失败！');
        return false;
      }
      $$tracker.phoneReservation('成功');
      void sendSemReport('btForm');
      if (data?.is_frist) Toast.success('预约成功！');

      this.onClickClose();
      this.successCallBack();
    } catch (error) {
      Toast.info(error.message || '预约失败');
    }
  };

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.closeCallback();
    this.clearStyle();
  };

  use() {
    // 不调用 super.use()，避免自动激活弹窗
    // super.use();
    // 弹窗的显示由外部手动控制 isOpen 和 isActive
  }
}

export default OrderModalStore;
